"use strict";

import $ from "jquery";
import "select2";

const profilesTeam = {
  formatTeams(teams) {
    if (teams.id) {
      let $team = $(`
      <div class="row">
        <img src="${teams.cover}" width="50" style="margin: 0 20px;">
        <span class="c-drop-template__title">${teams.text}<br/ >
          Líder: ${teams.description}
        </span>
      </div>
    `);
      return $team;
    }
    return "Selecione uma equipe";
  },

  init() {
    let teams = JSON.parse(sessionStorage.teams);
    let team_selected = JSON.parse(sessionStorage.team_selected);

    $("#js-team").select2({
      placeholder: "Selecione",
      theme: "classic",
      data: teams,
      multiple: false,
      templateSelection: $this.formatTeams,
      templateResult: $this.formatTeams,
    });

    $("#js-team").val(team_selected);
    $("#js-team").trigger("change");
  },
};
const $this = profilesTeam;

export default profilesTeam;
